// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zobA7Od_xcc9WpGVDqYX {
  padding: 0.5em 0.5em 1em 0.5em;
  background-color: var(--background);
  user-select: none;
}
.zobA7Od_xcc9WpGVDqYX > li {
  display: flex;
  gap: 0.5em;
  align-items: start;
  background-color: var(--background);
  border: 1px solid var(--border-color);
  border-left-width: 5px;
  border-radius: var(--dry-border-radius);
  padding: 0.5em 0.5em;
  margin-bottom: 0.5em;
}
.zobA7Od_xcc9WpGVDqYX > li > i {
  flex: 1.8em 0 0;
  height: 1.8em;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--bar-background);
  border-radius: 50%;
  font-size: 1.8em;
  margin-top: 0.5em;
}
.zobA7Od_xcc9WpGVDqYX > li > article {
  flex: 100% 1 1;
}
.zobA7Od_xcc9WpGVDqYX > li > article > h1 {
  font-weight: 600;
  line-height: 2em;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div {
  font-size: 0.9em;
  display: flex;
  gap: 0.5em;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) {
  flex: 100% 1 1;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) .path-breadcrumbs {
  margin: 0.2em 0;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) b {
  display: flex;
  gap: 0.5em;
  margin: 0.2em 0;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) b i {
  font-size: 1.5em;
  opacity: 0.6;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) b > span {
  flex: 0px 0 1;
  display: flex;
  align-items: center;
  gap: 0.5em;
  border: 1px solid var(--border-color);
  padding: 0.4em 0.8em 0.4em 0.4em;
  border-radius: 6px;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) b > span > span {
  display: flex;
  flex-direction: column;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) b > span > span > span {
  display: flex;
  gap: 0.2em;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) b > span > span > span > em {
  display: flex;
  gap: 0.4em;
  align-items: center;
  white-space: nowrap;
  background-color: var(--bar-background);
  padding: 0.1em 0.4em;
  border-radius: 8px;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) b > span > span > span > em > i {
  font-size: 0.9em;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) * {
  color: var(--bar-color);
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) > mark {
  display: inline-flex;
  align-items: center;
  gap: 0.4em;
  border-radius: 5px;
  padding: 0.2em 0.6em;
  margin-top: 0.5em;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) > mark.synced {
  background-color: var(--success-bg);
  color: var(--success-color);
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) > mark.synced > * {
  color: var(--success-color);
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) > mark.syncing {
  background-color: var(--info-bg);
  color: var(--info-color);
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(1) > mark.syncing > i {
  color: var(--info-color);
  animation: rotate360 2s linear infinite;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(2) {
  display: flex;
  justify-content: center;
  align-items: start;
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(2) > button {
  font-size: 1.8em;
  opacity: 0.8;
  cursor: pointer;
  color: var(--attention-color);
}
.zobA7Od_xcc9WpGVDqYX > li > article > div > :nth-child(2) > button:hover {
  opacity: 1;
}
.zobA7Od_xcc9WpGVDqYX > li:last-child {
  margin: 0;
}
@keyframes rotate360 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `zobA7Od_xcc9WpGVDqYX`,
	"pathBreadcrumbs": `path-breadcrumbs`,
	"synced": `synced`,
	"syncing": `syncing`
};
export default ___CSS_LOADER_EXPORT___;
